import React from "react";
import { DatePicker } from "antd";
import "antd/dist/antd.css";

export default function SelectDateTime({ headerComponents }) {

  function onChange(value, dateString) {
    // console.log("Selected Time: ", value);
    // console.log("Formatted Selected Time: ", dateString);
  }

  return (
    <div className="div-DatePicker-style-custom">
      <p className="text-header-date-picker">{headerComponents}</p>
      <DatePicker
        className="DatePicker-style-custom"
        showTime
        onChange={onChange}
      />
    </div>
  );
}
